//
//
//
//
//
//
//

/* eslint-disable */
export default {
  name: "loadings",
  props:[],
  data() {
    return {
     loads:true
    };
  },
  created() {
    window.setTimeout(() => {
      this.loads = false;
    }, 1000);
  },
};



// WEBPACK FOOTER //
// ./src/components/loadings.vue